import { Routes, Route } from "react-router-dom";
import AdminApp from "./admin/pages/Admin";

export default function App() {

  // redirect root to customer site
  if (window.location.pathname === "/") {
    window.location.href = "https://www.varaii.com";
    return null;
  }

  // redirect any wrong admin URL
  if (!window.location.pathname.startsWith("/admin9982649982mys986532")) {
    window.location.href = "https://www.varaii.com";
    return null;
  }

  return (
    <Routes>
      {/* Secret Admin Route */}
      <Route path="/admin9982649982mys986532/*" element={<AdminApp />} />
    </Routes>
  );
}